function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import { useEffect, useState } from "react";
import { getDates } from "./helpers/getDates.js";
import { getDays } from "./helpers/getDays.js";
import { getDisplayMonths } from "./helpers/getDisplayMonths.js";
import { getInitialMonth } from "./helpers/getInitialMonth.js";
import { getMonths } from "./helpers/getMonths.js";
import { getNavMonths } from "./helpers/getNavMonth.js";
import { getNextMonth } from "./helpers/getNextMonth.js";
import { getPreviousMonth } from "./helpers/getPreviousMonth.js";
import { getWeeks } from "./helpers/getWeeks.js";
/** @private */
export function useCalendar(props, dateLib) {
  var _getNavMonths = getNavMonths(props, dateLib),
    _getNavMonths2 = _slicedToArray(_getNavMonths, 2),
    navStart = _getNavMonths2[0],
    navEnd = _getNavMonths2[1];
  var startOfMonth = dateLib.startOfMonth,
    endOfMonth = dateLib.endOfMonth;
  var initialMonth = getInitialMonth(props, dateLib);
  var _useState = useState(initialMonth),
    _useState2 = _slicedToArray(_useState, 2),
    firstMonth = _useState2[0],
    setFirstMonth = _useState2[1];
  // Update the displayed month if `month` changes
  useEffect(function () {
    var initialDisplayMonth = getInitialMonth(props, dateLib);
    setFirstMonth(initialDisplayMonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.month]);
  // Update the displayed month if start/end month changes
  useEffect(function () {
    // TOFIX: this effect should do nothing if the current firstMonth is between
    // startMonth and endMonth
    var initialDisplayMonth = getInitialMonth(props, dateLib);
    setFirstMonth(initialDisplayMonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.startMonth, props.endMonth]);
  /** The months displayed in the calendar. */
  var displayMonths = getDisplayMonths(firstMonth, navEnd, props, dateLib);
  /** The dates displayed in the calendar. */
  var dates = getDates(displayMonths, props.endMonth ? endOfMonth(props.endMonth) : undefined, props, dateLib);
  /** The Months displayed in the calendar. */
  var months = getMonths(displayMonths, dates, props, dateLib);
  /** The Weeks displayed in the calendar. */
  var weeks = getWeeks(months);
  /** The Days displayed in the calendar. */
  var days = getDays(months);
  var previousMonth = getPreviousMonth(firstMonth, navStart, props, dateLib);
  var nextMonth = getNextMonth(firstMonth, navEnd, props, dateLib);
  var disableNavigation = props.disableNavigation,
    onMonthChange = props.onMonthChange;
  var isDayInCalendar = function isDayInCalendar(day) {
    return weeks.some(function (week) {
      return week.days.some(function (d) {
        return d.isEqualTo(day);
      });
    });
  };
  var goToMonth = function goToMonth(date) {
    if (disableNavigation) {
      return;
    }
    var newMonth = startOfMonth(date);
    // if month is before start, use the first month instead
    if (navStart && newMonth < startOfMonth(navStart)) {
      newMonth = startOfMonth(navStart);
    }
    // if month is after endMonth, use the last month instead
    if (navEnd && newMonth > startOfMonth(navEnd)) {
      newMonth = startOfMonth(navEnd);
    }
    setFirstMonth(newMonth);
    onMonthChange === null || onMonthChange === void 0 || onMonthChange(newMonth);
  };
  var goToDay = function goToDay(day) {
    // is this check necessary?
    if (isDayInCalendar(day)) {
      return;
    }
    goToMonth(day.date);
  };
  var calendar = {
    months: months,
    weeks: weeks,
    days: days,
    navStart: navStart,
    navEnd: navEnd,
    previousMonth: previousMonth,
    nextMonth: nextMonth,
    goToMonth: goToMonth,
    goToDay: goToDay
  };
  return calendar;
}